import {
    Component,
    ChangeDetectionStrategy,
    OnDestroy,
    Input,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { TeamPortalWindow } from '../team-portal-window/team-portal-window.cmp';
import { AppConfig, ModalController } from 'flux-core';
import { configLanguages } from 'apps/nucleus/src/config/config-languages';

@Component({
    selector: 'pay-per-canceled-message',
    templateUrl: './pay-per-canceled-message.cmp.html',
    styleUrls: [ 'pay-per-canceled-message.scss' ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PayPerCanceledMessage implements OnDestroy {

    /**
     * This holds value for show pay per canceled message
     */
    @Input() public showPayPerCanceledMessage: boolean = false;


    /**
     * Current user data subscription, must remove upon destroy.
     */
    protected subs: Array<Subscription>;

    /**
     * Constructor
     */
    public constructor(
        protected modalController: ModalController,
        public translate: TranslateService,
    ) {
        this.subs = [];
    }

    /**
     * Unsubscribe from all subscriptions.
     */
    public ngOnDestroy() {
        while ( this.subs.length > 0 ) {
            this.subs.pop().unsubscribe();
        }
    }

    public renewSubscription() {
        this.modalController.show( TeamPortalWindow , { inputs: { page: 'close' }});
    }

    public showPlanPage() {
        const currentLang = this.translate.currentLang;
        const planPageUrl = configLanguages[currentLang]?.plans_page || configLanguages.en.plans_page;
        window.open( AppConfig.get('SITE_URL') + planPageUrl, '_blank' );
    }
}
